import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import tradeShowService from '../../services/tradeShowService';

const BUSINESS_TYPES = [
  { value: '', label: 'Select one (optional)' },
  { value: 'retail', label: 'Retail' },
  { value: 'food_service', label: 'Food Service' },
  { value: 'distributor', label: 'Distributor' },
  { value: 'other', label: 'Other' },
];

// Public, no-login self-serve lead capture — a visitor scans the booth's QR code and lands here.
export default function TradeShowCapturePage() {
  const { token } = useParams();
  const [show, setShow] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [form, setForm] = useState({ fullName: '', email: '', phone: '', businessName: '', businessType: '', notes: '', website: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    tradeShowService.getPublicTradeShow(token).then(setShow).catch(() => setLoadError(true));
  }, [token]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName.trim()) { setError('Please enter your name.'); return; }
    setSubmitting(true); setError('');
    try {
      await tradeShowService.submitPublicLead(token, form);
      setSubmitted(true);
    } catch (err) {
      setError(err?.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loadError) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center text-muted">This link isn't valid.</div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center px-3" style={{ minHeight: '100vh', background: '#f4f6f9' }}>
      <div className="card shadow-sm" style={{ maxWidth: 440, width: '100%' }}>
        <div className="card-body p-4">
          {!show ? (
            <div className="text-center py-4"><span className="spinner-border spinner-border-sm" /></div>
          ) : submitted ? (
            <div className="text-center py-4">
              <div style={{ fontSize: 40 }}>🎉</div>
              <h5 className="mt-2">Thanks!</h5>
              <p className="text-muted mb-0">We've got your info — we'll be in touch soon.</p>
            </div>
          ) : (
            <>
              <h5 className="mb-1">{show.name}</h5>
              <p className="text-muted mb-4" style={{ fontSize: 13 }}>{show.location} · Leave your info and we'll follow up!</p>
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}
                <div className="mb-2">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Full Name *</label>
                  <input className="form-control" value={form.fullName} onChange={e => set('fullName', e.target.value)} autoFocus />
                </div>
                <div className="mb-2">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Email</label>
                  <input type="email" className="form-control" value={form.email} onChange={e => set('email', e.target.value)} />
                </div>
                <div className="mb-2">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Phone</label>
                  <input className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} />
                </div>
                <div className="mb-2">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Business Name</label>
                  <input className="form-control" value={form.businessName} onChange={e => set('businessName', e.target.value)} />
                </div>
                <div className="mb-2">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Type of Business</label>
                  <select className="form-select" value={form.businessType} onChange={e => set('businessType', e.target.value)}>
                    {BUSINESS_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label mb-1" style={{ fontSize: 13 }}>Notes</label>
                  <textarea className="form-control" rows={2} value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Anything you'd like us to know?" />
                </div>
                {/* Honeypot — hidden from real visitors via CSS, bots tend to fill every field */}
                <input
                  type="text" tabIndex={-1} autoComplete="off" value={form.website}
                  onChange={e => set('website', e.target.value)}
                  style={{ position: 'absolute', left: '-9999px', width: 1, height: 1 }}
                  aria-hidden="true"
                />
                <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
                  {submitting ? 'Submitting…' : 'Submit'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
